/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "0.1.0 nightly 2025-06-19",
    versionChannel: "nightly",
    buildDate: "2025-06-19T00:07:17.474Z",
    commitHash: "dc22b9916f2003b320e692ff8581f0c084b89f94",
};
